import {
  SlideFade as ChakraSlideFade,
  ScaleFade as ChakraScaleFade,
  Fade as ChakraFade,
} from "@chakra-ui/react";

const SlideFade = ChakraSlideFade;
const ScaleFade = ChakraScaleFade;
const Fade = ChakraFade;

export { SlideFade, ScaleFade, Fade };
